<template>
  <user-booking v-if="stage==1" @selected="finishStageFirst"></user-booking>
  <location-select v-else-if="stage==2" :user="[user_rut]" @selected="finishStageSecond"></location-select>
  <sublocation-select v-else-if="stage==3" :location="[location]" @selected="finishStageThird"></sublocation-select>
  <date-select
    v-else-if="stage==4"
    :user="[user_rut]"
    :sublocation="[sublocation]"
    @selected="finishStageFourth"
  ></date-select>
  <time-select
    v-else-if="stage==5"
    :sublocation="sublocation.id"
    :date="dataSelector.init"
    @selected="sendCreationRequest"
  ></time-select>

  <alert-modal v-else-if="getIsInAlert()"></alert-modal>
</template>

<script>
import UserBooking from "./UserBooking.vue";
import LocationSelect from "./LocationSelect.vue";
import SublocationSelect from "./SublocationSelect.vue";
import DateSelect from "./DateSelect.vue";
import TimeSelect from "./TimeSelect.vue";

export default {
  data() {
    return {
      stage: 0,
      searching_rut: "",
      booking: {
        sublocation_id: "",
        weekday: "",
        start_time: "",
        end_time: "",
        day_schedule: null,
        local_time: ""
      },
      location: {
        name: "",
        id: 0,
        time_zone: ""
      },
      sublocation: {
        name: "",
        id: 0
      },
      dataSelector: {
        init: "",
        end: ""
      },
      user_rut: "",
      rules: {
        required: value => !!value || "Required."
      },
      counter_location_id: "",
      counter_location_name: "",
      user_finded: false,
      valid: false
    };
  },
  components: {
    UserBooking,
    LocationSelect,
    SublocationSelect,
    DateSelect,
    TimeSelect
  },
  computed: {
    timeZoneLocal: function() {
      let resolvedOptions = Intl.DateTimeFormat().resolvedOptions();
      return resolvedOptions.timeZone;
    }
  },
  methods: {
    sendBookingRequest() {
      var vm = this;
      var myData = { attributes: this.booking, user_id: this.user_rut };
      try {
        vm.$http
          .post("app/bookings/counter_booking_create", {
            headers: {
              "X-Device-ID": this.getDeviceId(),
              Authorization: "Bearer " + this.getUserToken()
            },
            data: vm.encrypt(myData).toString()
          })
          .then(
            function(response) {
              if (
                response.body.meta != undefined &&
                response.body.meta != null
              ) {
                if (
                  response.body.meta.authentication_token != undefined &&
                  response.body.meta.authentication_token != null
                ) {
                  this.checkToken(response.body.meta.authentication_token);
                }
              }
              if (response.body && response.status == 201) {
                this.updateAlertMessage("Reserva creada con éxito");
                this.updateIsInAlert(true);
                if(this.getUserType()==='Admin'){
                  vm.$router.push({name: 'access'})
                }else if(this.getUserType()==='Counter'){
                  vm.$router.push({
                    name: "location_access",
                    params: {
                      id: vm.counter_location_id,
                      filter: false,
                      date: new Date().toISOString().substr(0, 10),
                      date2: new Date().toISOString().substr(0, 10),
                      namex: vm.counter_location_name
                    }
                  });
                }
                
              }
            },
            function(response) {
              if (
                response.body.meta != undefined &&
                response.body.meta != null
              ) {
                if (
                  response.body.meta.authentication_token != undefined &&
                  response.body.meta.authentication_token != null
                ) {
                  this.checkToken(response.body.meta.authentication_token);
                }
              }
              if (response.status === 402) {
                console.log("===NewBooking=== 402 ===", response);
                this.updateAlertMessage(
                  response.body.ans
                );
                this.updateIsInAlert(true);
              }

              console.log("Respuesta error de reservas");
              if (response.status == 401) {
                // this.updateAlertMessage(response.body.errors[0].details, "Un momento...");
                this.updateAlertMessage("Debes volver a loguearte");
                this.updateIsInAlert(true);
              } else {
                try {
                  this.updateAlertMessage(response.body.errors[0].details);
                  this.updateIsInAlert(true);
                } catch (error) {
                  console.log("Error NewBooking ", error);
                }
              }
            }
          );
      } catch (e) {
        console.log("Fallo reservas creación");
        this.updateAlertMessage(e.message);
        this.updateIsInAlert(true);
      }

      vm.is_changed = false;
    },
    finishStageFirst(user_rut) {
      this.user_rut = user_rut;
      this.stage = 2;
    },
    finishStageSecond(location) {
      this.location.id = location.id;
      this.location.name = location.name;
      this.location.time_zone = location.time_zone;
      console.log("CHANGING...", location);
      this.stage = 3;
    },
    finishStageThird(sublocation) {
      this.sublocation.id = sublocation.id;
      this.sublocation.name = sublocation.name;
      this.booking.sublocation_id = sublocation.id;
      console.log("CHANGING...", sublocation);
      this.stage = 4;
    },
    finishStageFourth(datapicker) {
      console.log("EMIT", datapicker);
      let arr = datapicker.toISOString();
      let offset = new Date().getTimezoneOffset();
      this.dataSelector.init = new Date(
        new Date(arr).getTime() + offset * 60000
      );
      this.dataSelector.end = new Date(
        new Date(arr).getTime() + offset * 60000
      );
      console.log(arr);
      console.log("CHANGING...", this.dataSelector);
      this.booking.weekday = this.getWeekDay(this.dataSelector.init);
      this.stage = 5;
    },
    sendCreationRequest(bookingPicker) {
      if (
        bookingPicker.start_time === null &&
        bookingPicker.end_time === null &&
        bookingPicker.index === null
      ) {
        this.stage = 3;
      } else {
        console.log("OJO", bookingPicker);
        this.send_show_modal = false;
        var iniHourArr = bookingPicker.start_time.split(":");
        this.booking.start_time = this.mixDateHour(
          this.dataSelector.init,
          Number(iniHourArr[0]),
          Number(iniHourArr[1])
        );
        var endHourArr = bookingPicker.end_time.split(":");
        this.booking.end_time = this.mixDateHour(
          this.dataSelector.end,
          Number(endHourArr[0]),
          Number(endHourArr[1])
        );
        this.booking.local_time = bookingPicker.start_time;
        this.booking.day_schedule = bookingPicker.index;
        console.log("SENDING", this.booking);
        this.sendBookingRequest();
      }
    },
    mixDateHour(date, hour, minutes) {
      let myDate = date;
      myDate.setHours(hour);
      myDate.setMinutes(minutes);

      let offset = new Date().getTimezoneOffset();
      let a = new Date()
        .toLocaleString("ja", { timeZone: this.location.time_zone })
        .split(/[/\s:]/);
      a[1] = a[1] - 1;
      let t1 = Date.UTC.apply(null, a);
      let t2 = new Date().setMilliseconds(0);
      let bookingOffset = (t2 - t1) / 60 / 1000;
      let ans = new Date(
        myDate.getTime() - offset * 60000 + bookingOffset * 60000
      );

      return ans.toJSON();
    },
    getWeekDay(value) {
      var myTime = value.getDay();
      var weekday = null;
      if (!isNaN(myTime)) {
        weekday = [
          "sunday",
          "monday",
          "tuesday",
          "wednesday",
          "thursday",
          "friday",
          "saturday"
        ][myTime];
      }
      return weekday;
    }
  } /* closed methods */,
  mounted() {
    var vm = this;
    this.stage = 1;
    this.counter_location_id = this.$route.params.id;
    this.counter_location_name = this.$route.params.location_name;    
  }
};
</script>


// WEBPACK FOOTER //
// src/components/views/bookings/Index.vue